import { render, staticRenderFns } from "./XtendActions.vue?vue&type=template&id=6a401f85&"
import script from "./XtendActions.vue?vue&type=script&lang=js&"
export * from "./XtendActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports